import ExternalSyncPage from "./pages/ExternalSyncPage.vue";

export default {
    ExternalSyncPage,
};
